import { render, staticRenderFns } from "./HistoriaNinoV2.vue?vue&type=template&id=f55dbd3c&scoped=true"
import script from "./HistoriaNinoV2.vue?vue&type=script&lang=js"
export * from "./HistoriaNinoV2.vue?vue&type=script&lang=js"
import style0 from "./HistoriaNinoV2.vue?vue&type=style&index=0&id=f55dbd3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55dbd3c",
  null
  
)

export default component.exports